import { Modal } from 'react-bootstrap';

type BrokerageModalProps = {
  titleCls: string;
  children: React.ReactElement;
  title: string;
  show: boolean;
  onClose: () => void;
};
export const BrokerageModal = ({ titleCls, show, onClose, title, children }: BrokerageModalProps) => {
  return (
    <Modal className="brokerage-modal" show={show} onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          <span className={titleCls}>{title}</span>
        </Modal.Title>

        <div className="float-end" style={{ cursor: 'pointer' }} onClick={onClose}>
          <span>
            <i className="fa-regular fa-xmark"></i>
          </span>
        </div>
      </Modal.Header>

      <Modal.Body>{children}</Modal.Body>

      <Modal.Footer>
        <div onClick={onClose} className="btn btn-outline-primary">
          Close
        </div>
      </Modal.Footer>
    </Modal>
  );
};
